import { allGames, GameConfig } from '@/config/game';

export function getGameByShortname(shortname = ''): GameConfig | undefined {
  return allGames.find(
    (g) => g.shortname.toLowerCase() === shortname.toLowerCase()
  );
}
